import React, { memo } from 'react';
import { StyledBadge } from './styled';
export const Badge = /*#__PURE__*/memo(_ref => {
  let {
    className,
    style,
    label,
    ...props
  } = _ref;
  return typeof label === 'string' ? /*#__PURE__*/React.createElement(StyledBadge, props, label) : null;
});
Badge.displayName = 'Badge';